(function () {
  'use strict';

  const WORKER = 'https://wispy-rain-c7af.chris-646.workers.dev';

  function debugSetLoaded() {
    const el = document.getElementById('sf-debug-js');
    if (el) el.textContent = 'YES';
  }
  function debugSetErr(err) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = String(err && err.stack ? err.stack : err);
  }
  function debugLog(line) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = (el.textContent ? el.textContent + '\n' : '') + String(line);
  }
  window.addEventListener('error', (e) => debugSetErr(e.error || e.message || e));
  window.addEventListener('unhandledrejection', (e) => debugSetErr(e.reason || e));
  debugSetLoaded();

  const wrapper = document.getElementById('support-flow');
  const main    = document.getElementById('sf-main');
  if (!wrapper || !main) return;

  const cfg          = document.getElementById('sf-login-config');
  const LOGIN_BASE   = cfg?.dataset?.loginBase   || '/customer_authentication/login';
  const SUPPORT_PATH = cfg?.dataset?.supportPath || '/pages/contact-support';

  function buildLoginUrl(returnHash) {
    const returnTo = SUPPORT_PATH + (returnHash ? '#' + returnHash : '');
    return LOGIN_BASE + '?return_to=' + encodeURIComponent(returnTo);
  }

  // ── Customer identity ──────────────────────────────────────────────────────
  const customerEmail = (wrapper.dataset.customerEmail || '').trim();
  const customerName  = (wrapper.dataset.customerName  || '').trim();
  const customerFirst = customerName.split(' ')[0] || customerName;
  const customerId    = (wrapper.dataset.customerId    || '').trim();
  const customerTs    = (wrapper.dataset.customerTs    || '').trim();
  const customerSig   = (wrapper.dataset.customerSig   || '').trim();

  const isLoggedIn = () =>
    (wrapper.dataset.loggedIn || '').toString().toLowerCase() === 'true' ||
    customerEmail.length > 0;

  function hasTpl(id) { return !!document.getElementById(id); }
  function tpl(id) {
    const t = document.getElementById(id);
    if (!t || !t.content) throw new Error('Missing template #' + id);
    return t.content.cloneNode(true);
  }

  function show(content) {
    main.innerHTML = '';
    main.appendChild(content);
    const heading = main.querySelector('h1, h2, h3, [role="heading"]');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: false });
    }
  }

  function escapeHtml(s) {
    return (s || '').toString()
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;').replaceAll('"', '&quot;');
  }
  function renderFatal(err) {
    debugSetErr(err);
    const box = document.createElement('div');
    box.className = 'sf-card';
    box.innerHTML = `<h2 class="sf-title">Error</h2>
      <pre style="white-space:pre-wrap">${escapeHtml(String(err?.stack || err))}</pre>`;
    show(box);
  }

  for (const id of [
    'tpl-choose-category', 'tpl-choose-issue', 'tpl-not-logged-in',
    'tpl-select-orders', 'tpl-order-card', 'tpl-dropzone', 'tpl-item-check',
    'tpl-missing-item-new', 'tpl-damaged-packaging', 'tpl-damaged-items',
    'tpl-damaged-item-detail', 'tpl-damaged-extra', 'tpl-contact-form',
    'tpl-success', 'tpl-success-nologin', 'tpl-something-else'
  ]) {
    if (!hasTpl(id)) { renderFatal(new Error('Missing template: ' + id)); return; }
  }

  // ── API helpers ────────────────────────────────────────────────────────────
  function authenticatedHeaders() {
    return {
      'X-Customer-Email': customerEmail,
      'X-Customer-ID':    customerId,
      'X-Customer-TS':    customerTs,
      'X-Customer-Sig':   customerSig,
    };
  }
  async function apiPost(path, body) {
    const res = await fetch(WORKER + path, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', ...authenticatedHeaders() },
      body:    JSON.stringify(body || {})
    });
    const d = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
    return d;
  }
  async function apiGet(path) {
    const res = await fetch(WORKER + path, { headers: authenticatedHeaders() });
    const d   = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
    return d;
  }

  // ── Uploader ───────────────────────────────────────────────────────────────
  function mountUploader(container, { label = 'Attach files', multiple = true } = {}) {
    if (!container) return { getKeys: () => [], isUploading: () => false };
    const frag  = tpl('tpl-dropzone');
    const dz    = frag.querySelector('.sf-dropzone');
    const input = frag.querySelector('input[type="file"]');
    const btn   = frag.querySelector('.sf-attach-btn');
    const list  = frag.querySelector('.sf-file-list');
    if (btn) btn.textContent = '📎 ' + label;
    if (multiple && input) input.setAttribute('multiple', '');
    container.innerHTML = '';
    container.appendChild(frag);
    let staged = [];
    function isUploading() { return staged.some(s => s.status === 'uploading'); }
    function render() {
      if (!list) return;
      list.innerHTML = '';
      staged.forEach((e, idx) => {
        const row   = document.createElement('div');
        row.className = 'sf-file-item';
        const name  = document.createElement('span');
        name.textContent = e.file.name;
        const badge = document.createElement('span');
        badge.className   = 'sf-file-badge ' + (e.status || '');
        badge.textContent = e.status === 'uploading' ? '⏳' : e.status === 'done' ? '✓' : '✗';
        badge.setAttribute('aria-hidden', 'true');
        const del = document.createElement('button');
        del.type        = 'button';
        del.className   = 'sf-file-del';
        del.textContent = '✕';
        del.setAttribute('aria-label', 'Remove ' + e.file.name);
        del.addEventListener('click', () => { staged.splice(idx, 1); render(); });
        row.append(name, badge, del);
        list.appendChild(row);
      });
    }
    async function uploadOne(entry) {
      const fd = new FormData();
      fd.append('file', entry.file);
      try {
        const res  = await fetch(WORKER + '/upload', { method: 'POST', body: fd });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.success) throw new Error(data.error || 'Upload failed');
        entry.key = data.key; entry.status = 'done';
      } catch { entry.status = 'error'; }
      render();
    }
    function handleFiles(files) {
      for (const f of files) {
        if (staged.length >= 10) break;
        staged.push({ file: f, key: null, status: 'uploading' });
        render();
        uploadOne(staged[staged.length - 1]);
      }
    }
    btn?.addEventListener('click', () => input?.click());
    input?.addEventListener('change', () => { handleFiles([...(input.files || [])]); input.value = ''; });
    dz?.addEventListener('dragover',  e => { e.preventDefault(); dz.classList.add('dragover'); });
    dz?.addEventListener('dragleave', () => dz.classList.remove('dragover'));
    dz?.addEventListener('drop', e => {
      e.preventDefault(); dz.classList.remove('dragover');
      handleFiles([...(e.dataTransfer?.files || [])]);
    });
    return { getKeys: () => staged.filter(s => s.key).map(s => s.key), isUploading };
  }

  // ── Status messages ────────────────────────────────────────────────────────
  function setStatus(msg, kind) {
    const el = document.querySelector('#sf-main .sf-status-msg');
    if (!el) return;
    el.textContent = msg || '';
    el.className   = 'sf-status-msg' + (kind ? ' ' + kind : '');
    el.setAttribute('role',      kind === 'error' ? 'alert'     : 'status');
    el.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
  }

  function formatDate(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  function fulfilLabel(o) {
    if (!o?.dispatched_at)                    return '⏳ Being prepared';
    if (o.fulfillment_status === 'fulfilled') return '✅ Dispatched';
    return '📦 Partially dispatched';
  }

  // ── DOM helpers ────────────────────────────────────────────────────────────
  function makeLink(href, text, className) {
    const a = document.createElement('a');
    a.href        = href;
    a.textContent = text;
    if (className) a.className = className;
    return a;
  }
  function makeTrackingPara(trackingUrl, trackingNumber) {
    const p    = document.createElement('p');
    const link = makeLink(trackingUrl, '📦 Track your order', 'sf-link');
    link.target = '_blank';
    link.rel    = 'noopener';
    p.appendChild(link);
    if (trackingNumber) p.appendChild(document.createTextNode(' (' + trackingNumber + ')'));
    return p;
  }
  function makeCard() {
    const el = document.createElement('div');
    el.className = 'sf-card';
    return el;
  }
  function makeBackButton() {
    const btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'sf-back';
    btn.setAttribute('data-action', 'back');
    btn.textContent = '← Back';
    return btn;
  }
  function makeHeading(text) {
    const h = document.createElement('h2');
    h.className   = 'sf-title';
    h.textContent = text;
    return h;
  }
  function makeSubtitle(text) {
    const p = document.createElement('p');
    p.className   = 'sf-subtitle';
    p.textContent = text;
    return p;
  }
  function makeStatusEl() {
    const el = document.createElement('div');
    el.className = 'sf-status-msg';
    el.setAttribute('role',        'status');
    el.setAttribute('aria-live',   'polite');
    el.setAttribute('aria-atomic', 'true');
    return el;
  }
  function makeButton(text, action, className = 'sf-btn') {
    const btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = className;
    if (action) btn.setAttribute('data-action', action);
    btn.textContent = text;
    return btn;
  }
  function makeOption(icon, text, action, dataAttr) {
    const btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'sf-option';
    if (action)   btn.setAttribute('data-action', action);
    if (dataAttr) btn.setAttribute(dataAttr.name, dataAttr.value);
    const iconEl = document.createElement('span');
    iconEl.className   = 'sf-option-icon';
    iconEl.textContent = icon;
    iconEl.setAttribute('aria-hidden', 'true');
    const textEl = document.createElement('span');
    textEl.textContent = text;
    btn.append(iconEl, textEl);
    return btn;
  }
  function makeOptionsContainer(marginTop) {
    const el = document.createElement('div');
    el.className = 'sf-options';
    if (marginTop) el.style.marginTop = marginTop;
    return el;
  }
  function makeOrderNamePara(prefix, orderName, suffix) {
    const p = document.createElement('p');
    p.className = 'sf-subtitle';
    if (prefix) p.appendChild(document.createTextNode(prefix));
    const strong = document.createElement('strong');
    strong.textContent = orderName || '';
    p.appendChild(strong);
    if (suffix) p.appendChild(document.createTextNode(suffix));
    return p;
  }
  function makeField(labelText, inputEl) {
    const lbl  = document.createElement('label');
    lbl.className     = 'sf-label';
    lbl.style.cssText = 'display:block;margin-bottom:12px;';
    const span = document.createElement('span');
    span.style.cssText = 'display:block;margin-bottom:4px;font-weight:600;';
    span.textContent   = labelText;
    lbl.appendChild(span);
    lbl.appendChild(inputEl);
    return lbl;
  }
  function makeInput(className, type, placeholder, value = '') {
    const el         = document.createElement('input');
    el.className     = 'sf-input ' + className;
    el.type          = type;
    el.placeholder   = placeholder;
    el.value         = value;
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;';
    return el;
  }
  function makeTextarea(className, rows, placeholder, value = '') {
    const el         = document.createElement('textarea');
    el.className     = 'sf-input ' + className;
    el.rows          = rows;
    el.placeholder   = placeholder;
    el.value         = value;
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;min-height:220px;resize:vertical;line-height:1.5;';
    return el;
  }

  // ── Warning hint box ───────────────────────────────────────────────────────
  function makeHintBox(text) {
    const box = document.createElement('div');
    box.className = 'sf-hint-box';
    box.style.cssText = [
      'display:flex', 'align-items:flex-start', 'gap:10px',
      'background:#fffbea', 'border:1px solid #f5c842',
      'border-left:4px solid #f5c842', 'border-radius:6px',
      'padding:12px 14px', 'margin:12px 0 16px',
      'font-size:.92em', 'color:#7a5c00', 'line-height:1.5',
    ].join(';');
    const icon = document.createElement('span');
    icon.textContent = '⚠️';
    icon.style.cssText = 'flex-shrink:0;font-size:1.1em;margin-top:1px;';
    icon.setAttribute('aria-hidden', 'true');
    const msg = document.createElement('span');
    msg.textContent = text;
    box.append(icon, msg);
    return box;
  }

  // ── Info box (blue) ────────────────────────────────────────────────────────
  function makeInfoBox(htmlOrText, isHtml = false) {
    const box = document.createElement('div');
    box.className = 'sf-info-box';
    box.style.cssText = [
      'display:flex', 'align-items:flex-start', 'gap:10px',
      'background:#eef6ff', 'border:1px solid #90c8f8',
      'border-left:4px solid #2196f3', 'border-radius:6px',
      'padding:12px 14px', 'margin:16px 0',
      'font-size:.92em', 'color:#0d3c61', 'line-height:1.5',
    ].join(';');
    const icon = document.createElement('span');
    icon.textContent = 'ℹ️';
    icon.style.cssText = 'flex-shrink:0;font-size:1.1em;margin-top:1px;';
    icon.setAttribute('aria-hidden', 'true');
    const msg = document.createElement('span');
    if (isHtml) msg.innerHTML = htmlOrText;
    else        msg.textContent = htmlOrText;
    box.append(icon, msg);
    return box;
  }

  // ── Ticket context ─────────────────────────────────────────────────────────
  function buildTicketContext(extraLines = []) {
    const lines = ['--- Support Context ---'];
    lines.push('Customer: ' + (customerName  || '(unknown)'));
    lines.push('Email:    ' + (customerEmail || '(unknown)'));
    if (app.selectedOrder) {
      const o = app.selectedOrder;
      lines.push('Order:    ' + o.name + ' (' + o.id + ')');
      lines.push('Placed:   ' + formatDate(o.created_at));
      lines.push('Status:   ' + (o.fulfillment_status || 'unknown'));
      if (o.dispatched_at)   lines.push('Dispatched:   ' + formatDate(o.dispatched_at));
      if (o.tracking_number) lines.push('Tracking #:   ' + o.tracking_number);
      if (o.tracking_url)    lines.push('Tracking URL: ' + o.tracking_url);
    }
    if (app.issueType)       lines.push('Issue type:        ' + app.issueType);
    if (app.deliverySubType) lines.push('Delivery sub-type: ' + app.deliverySubType);
    if (app.missingItems?.length)
      lines.push('Missing items: ' + app.missingItems.map(x => x.title).join(', '));
    if (app.damagedItems?.length)
      lines.push('Damaged items: ' + app.damagedItems.map(x => x.title).join(', '));
    for (const l of extraLines) if (l) lines.push(l);
    lines.push('--- End Context ---');
    return lines.join('\n');
  }
  function withContext(userMessage, extraLines = []) {
    return buildTicketContext(extraLines) + '\n\n' + (userMessage || '(no message provided)');
  }

  // ── Prefill messages ───────────────────────────────────────────────────────
  function buildMissingItemMessage() {
    const orderName = app.selectedOrder?.name || '';
    const itemLines = app.missingItems.map((item, i) => `${i + 1}. ${item.title}`).join('\n');
    return [
      'Hi MycoPunks team,',
      '',
      `Some items were missing from my order (${orderName})`,
      '',
      itemLines,
      '',
      'Can you let me know next steps?',
      '',
      'Thanks,',
      customerFirst,
    ].join('\n');
  }

  function buildDeliveryNotReceivedMessage() {
    const orderName = app.selectedOrder?.name || '';
    return [
      'Hi MycoPunks team,',
      '',
      `Order ${orderName} says it was delivered, I've checked with neighbours and around my property and I can't find it.`,
      '',
      'Please can you let me know next steps?',
      '',
      'Thanks,',
      customerFirst,
    ].join('\n');
  }

  // ── Build ticket subject ───────────────────────────────────────────────────
  function buildSubject() {
    const ord  = app.selectedOrder;
    const name = ord?.name || '';
    const issueMap = {
      'missing-item': `${name} had missing items`,
      'damaged':      `${name} had damaged items`,
      'not-arrived':  `${name} — delivery problem`,
    };
    return 'Order ' + (issueMap[app.issueType] || (name ? name + ' — support request' : 'Support request'));
  }

  // ── Hash routing ───────────────────────────────────────────────────────────
  const TOP_HASHES = new Set(['', 'order-problem', 'website', 'cultivation', 'other']);
  function getTopHash() {
    const h = (window.location.hash || '').replace(/^#/, '').trim().toLowerCase();
    return TOP_HASHES.has(h) ? h : '';
  }
  function goTop(hash) {
    const h = hash || '';
    if (window.location.hash === (h ? '#' + h : '')) renderTop();
    else window.location.hash = h ? '#' + h : '';
  }

  // ── App state ──────────────────────────────────────────────────────────────
  const app = {
    top: '', step: '', stepStack: [],
    ordersLoaded: false, orders: [],
    issueType: null, selectedOrder: null,
    missingItems: [],
    packagingDamaged: null, parcelKeys: [],
    damagedItems: [], damagedItemDetails: {}, damagedIdx: 0,
    deliverySubType: null,
    uploaders: {},
    _contactTags: [],
  };

  function resetFlow() {
    app.stepStack = []; app.step = 'issue';
    app.issueType = null; app.selectedOrder = null;
    app.missingItems = [];
    app.packagingDamaged = null; app.parcelKeys = [];
    app.damagedItems = []; app.damagedItemDetails = {}; app.damagedIdx = 0;
    app.deliverySubType = null;
    app.uploaders = {};
    app._contactTags = [];
  }

  function pushStep(s) { if (app.step) app.stepStack.push(app.step); app.step = s; renderStep(); }
  function popStep()   { app.step = app.stepStack.pop() || 'issue'; renderStep(); }

  async function loadOrders() {
    if (app.ordersLoaded) return;
    const d = await apiGet('/orders');
    app.orders = d.orders || [];
    app.ordersLoaded = true;
  }

  // ── Item list ──────────────────────────────────────────────────────────────
  function buildItemList(lineItems, selectedIds, onToggle) {
    const wrap = document.createElement('div');
    wrap.className = 'sf-item-list';
    lineItems.forEach(li => {
      const row   = document.createElement('label');
      row.className = 'sf-item-check-row';
      row.style.cssText = 'display:flex;align-items:center;gap:12px;cursor:pointer;padding:10px 0;border-bottom:1px solid #f0f0f0;';
      const input = document.createElement('input');
      input.type    = 'checkbox';
      input.checked = selectedIds.has(String(li.id));
      input.addEventListener('change', () => onToggle(li, input.checked));
      const img = document.createElement('img');
      img.className     = 'sf-item-thumb';
      img.alt           = '';
      img.style.cssText = 'width:48px;height:48px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#f0f0f0;';
      img.setAttribute('aria-hidden', 'true');
      if (li.image) { img.src = li.image; } else { img.style.display = 'none'; }
      const text = document.createElement('span');
      text.className   = 'sf-item-label';
      text.textContent = li.title + (li.variant_title ? ' — ' + li.variant_title : '');
      row.append(input, img, text);
      wrap.appendChild(row);
    });
    return wrap;
  }

  // ── Order list ─────────────────────────────────────────────────────────────
  function buildOrderList(orders, selectedId, onSelect) {
    const group = document.createElement('div');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Select an order');
    orders.forEach(o => {
      const clone = tpl('tpl-order-card');
      const card  = clone.querySelector('.sf-order-card') || clone.firstElementChild;
      if (!card) return;
      const isSelected = String(o.id) === String(selectedId);
      card.setAttribute('data-order-id', String(o.id));
      card.setAttribute('role',          'radio');
      card.setAttribute('aria-checked',  String(isSelected));
      card.setAttribute('tabindex',      isSelected ? '0' : '-1');
      card.querySelectorAll('*').forEach(el => {
        el.setAttribute('data-order-id', String(o.id));
        el.style.pointerEvents = 'none';
      });
      const nameEl  = card.querySelector('.sf-order-name');
      const metaEl  = card.querySelector('.sf-order-meta');
      const itemsEl = card.querySelector('.sf-order-items');
      if (nameEl)  nameEl.textContent  = o.name || '';
      if (metaEl)  metaEl.textContent  = formatDate(o.created_at) + ' · ' + fulfilLabel(o);
      if (itemsEl) itemsEl.textContent = (o.line_items?.length || 0) + ' item(s)';
      if (isSelected) card.classList.add('selected');
      card.addEventListener('click', () => { onSelect(isSelected ? null : o); });
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(isSelected ? null : o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const next = card.nextElementSibling;
          if (next) { next.setAttribute('tabindex', '0'); next.focus(); card.setAttribute('tabindex', '-1'); }
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = card.previousElementSibling;
          if (prev) { prev.setAttribute('tabindex', '0'); prev.focus(); card.setAttribute('tabindex', '-1'); }
        }
      });
      group.appendChild(card);
    });
    return group;
  }

  // ── Not logged in ──────────────────────────────────────────────────────────
  function renderNotLoggedIn() {
    const frag = tpl('tpl-not-logged-in');
    const card = frag.querySelector('.sf-card') || frag.firstElementChild;
    if (!card) { show(frag); return; }
    const returnHash   = getTopHash() || 'order-problem';
    const loginUrl     = buildLoginUrl(returnHash);
    const registerBase = card.querySelector('a[href*="register"]')
      ?.getAttribute('href')?.split('?')[0] || '/account/register';
    const signupUrl = registerBase + '?return_to='
      + encodeURIComponent(SUPPORT_PATH + '#' + returnHash);
    card.innerHTML = '';
    card.appendChild(makeBackButton());
    card.appendChild(makeHeading('Contact Support'));
    card.appendChild(makeSubtitle('Please log in so we can pull up your orders.'));
    const info = document.createElement('div');
    info.className   = 'sf-info-box';
    info.textContent = 'Log in using the email address associated with your order.';
    card.appendChild(info);
    card.appendChild(makeLink(loginUrl, 'Log in to continue', 'sf-btn'));
    const guestNote = document.createElement('p');
    guestNote.className     = 'sf-guest-note';
    guestNote.style.cssText = 'margin-top:16px;font-size:.9em;color:#666;';
    guestNote.appendChild(document.createTextNode('Checked out as a guest? '));
    guestNote.appendChild(makeLink(signupUrl, 'Create an account', 'sf-link'));
    guestNote.appendChild(document.createTextNode(' using the email used for your order.'));
    card.appendChild(guestNote);
    show(frag);
  }

  // ── Success screen ─────────────────────────────────────────────────────────
  function renderSuccess() {
    const card = makeCard();
    card.appendChild(makeHeading('Request received ✓'));
    card.appendChild(makeSubtitle("We'll be in touch shortly via email."));
    card.appendChild(makeInfoBox(
      'Support is managed entirely via email. No need to create additional requests — simply reply to our email when you receive it.'
    ));
    card.appendChild(makeButton('← Back to support', 'back', 'sf-btn sf-btn--ghost'));
    show(card);
  }

  // ── Contact form (shared) ──────────────────────────────────────────────────
  function renderContactForm({ subject = '', message = '', tags = [] } = {}) {
    const card         = makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(makeBackButton());
    card.appendChild(makeHeading('Contact Support'));
    card.appendChild(makeSubtitle("Fill in the details below and we'll get back to you via email."));
    card.appendChild(makeStatusEl());
    if (!isLoggedIn()) {
      card.appendChild(makeField('Name',  makeInput('sf-cf-name',  'text',  'Your name',  customerName)));
      card.appendChild(makeField('Email', makeInput('sf-cf-email', 'email', 'Your email', customerEmail)));
    }
    card.appendChild(makeField('Subject', makeInput('sf-cf-subject', 'text', "What's it about?", subject)));
    card.appendChild(makeField('Message', makeTextarea('sf-cf-message', 10, 'Tell us more…', message)));
    card.appendChild(uploaderWrap);
    card.appendChild(makeButton('Send message', 'submit-contact'));
    app.uploaders.contact = mountUploader(uploaderWrap, { label: 'Attach files' });
    app._contactTags      = tags;
    show(card);
  }

  // ── Other/general contact form ─────────────────────────────────────────────
  function renderOtherForm() {
    const card         = makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(makeBackButton());
    card.appendChild(makeHeading('Get in touch'));
    card.appendChild(makeSubtitle("Fill in the form below and we'll get back to you via email."));
    card.appendChild(makeStatusEl());
    if (!isLoggedIn()) {
      card.appendChild(makeField('Name',  makeInput('sf-cf-name',  'text',  'Your name',  customerName)));
      card.appendChild(makeField('Email', makeInput('sf-cf-email', 'email', 'Your email', customerEmail)));
    }
    card.appendChild(makeField('Subject', makeInput('sf-cf-subject', 'text', "What's it about?")));
    card.appendChild(makeField('Message', makeTextarea('sf-cf-message', 10, 'Tell us more…')));
    card.appendChild(uploaderWrap);
    card.appendChild(makeButton('Send message', 'submit-other'));
    app.uploaders.other = mountUploader(uploaderWrap, { label: 'Attach files' });
    show(card);
  }

  // ── Top level ──────────────────────────────────────────────────────────────
  function renderTop() {
    const top = getTopHash();
    app.top = top;
    debugLog('top=' + (top || '(home)'));
    switch (top) {
      case '':
        show(tpl('tpl-choose-category'));
        return;
      case 'cultivation':
        show(hasTpl('tpl-cultivation') ? tpl('tpl-cultivation') : tpl('tpl-choose-category'));
        return;
      case 'website':
        if (hasTpl('tpl-website-problem')) {
          const f = tpl('tpl-website-problem');
          app.uploaders.website = mountUploader(f.querySelector('.sf-website-uploader'), { label: 'Attach screenshots' });
          show(f);
        } else show(tpl('tpl-choose-category'));
        return;
      case 'other':
        show(tpl('tpl-something-else'));
        return;
      case 'order-problem':
        if (!isLoggedIn()) { renderNotLoggedIn(); return; }
        resetFlow();
        renderStep();
        return;
    }
  }

  // ── Step render ────────────────────────────────────────────────────────────
  function renderStep() {
    debugLog('step=' + app.step);
    try {
      switch (app.step) {

        case 'issue': {
          const frag    = tpl('tpl-choose-issue');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'How can we help?';
          show(frag);
          break;
        }

        case 'select-order': {
          const frag    = tpl('tpl-select-orders');
          const heading = frag.querySelector('.sf-title, h2, h1');
          const headingMap = {
            'missing-item': 'Which order had missing items?',
            'damaged':      'Which order had damaged items?',
            'not-arrived':  'Which order had a delivery problem?',
          };
          if (heading) heading.textContent = headingMap[app.issueType] || 'Which order number was affected?';
          const list = frag.querySelector('#sf-order-list');
          if (!list) throw new Error('tpl-select-orders missing #sf-order-list');
          list.innerHTML = '';
          const orderGroup = buildOrderList(
            app.orders,
            app.selectedOrder ? String(app.selectedOrder.id) : null,
            (o) => { app.selectedOrder = o; renderStep(); }
          );
          list.appendChild(orderGroup);
          const cont = getContinueBtn(frag);
          if (cont) cont.disabled = !app.selectedOrder;
          show(frag);
          break;
        }

        case 'delivery-type': {
          const card = makeCard();
          const opts = makeOptionsContainer();
          opts.appendChild(makeOption('📭', "My order still hasn't arrived",                null, { name: 'data-delivery', value: 'not-received' }));
          opts.appendChild(makeOption('📍', "Tracking says delivered, but I don't have it", null, { name: 'data-delivery', value: 'wrong-address' }));
          opts.appendChild(makeOption('✉️', 'Other delivery problem',                        null, { name: 'data-delivery', value: 'other' }));
          card.appendChild(makeBackButton());
          card.appendChild(makeHeading('What happened with your delivery?'));
          card.appendChild(makeSubtitle('Select the option that best describes your issue.'));
          card.appendChild(opts);
          show(card);
          break;
        }

        case 'delivery-info': {
          const o    = app.selectedOrder;
          const card = makeCard();
          card.appendChild(makeBackButton());
          card.appendChild(makeHeading('Order status'));

          if (!o.dispatched_at) {
            // ── Not shipped yet ─────────────────────────────────────────────
            const p = document.createElement('p');
            p.className = 'sf-subtitle';
            p.innerHTML = 'Your order is still being prepared by our team. To get an idea of how long things might be, you can check our <a href="/pages/service-lead-times" class="sf-link">lead times page</a>.';
            card.appendChild(p);
            show(card);
            break;
          }

          const days = o.working_days_since_dispatch || 0;
          card.appendChild(makeOrderNamePara('Order ', o.name,
            ' was dispatched on ' + formatDate(o.dispatched_at) + '.'));
          if (o.tracking_url) card.appendChild(makeTrackingPara(o.tracking_url, o.tracking_number));
          card.appendChild(makeStatusEl());

          if (days < 4) {
            // ── Within 4 working days — soft roadblock ──────────────────────
            card.appendChild(makeHintBox(
              'It\'s only been ' + days + ' working day' + (days !== 1 ? 's' : '') +
              ' since we shipped your order. Please allow a little more time for it to arrive before raising a case.'
            ));
            card.appendChild(makeButton('I think there is a problem with the delivery', 'delivery-force-contact', 'sf-btn sf-btn--ghost'));
          } else {
            // ── Over 4 working days — proceed ───────────────────────────────
            const opts = makeOptionsContainer('16px');
            opts.appendChild(makeOption('🤷‍♂️', "I still haven't received it", 'delivery-still-missing'));
            card.appendChild(opts);
          }

          show(card);
          break;
        }

        case 'delivery-roadblock': {
          const card = makeCard();
          card.appendChild(makeBackButton());
          card.appendChild(makeHeading('Before we raise a case…'));
          card.appendChild(makeHintBox(
            'Sometimes couriers will leave items with neighbours or in a "safe place" — please check around your property and with nearby neighbours before continuing.'
          ));
          card.appendChild(makeStatusEl());
          const opts = makeOptionsContainer('16px');
          opts.appendChild(makeOption('🤷‍♂️', "I've checked and still can't find it", 'delivery-still-missing'));
          card.appendChild(opts);
          show(card);
          break;
        }

        case 'delivery-message': {
          renderContactForm({
            subject: buildSubject(),
            message: buildDeliveryNotReceivedMessage(),
            tags:    ['order', 'issue:delivery', 'subtype:not-received'],
          });
          break;
        }

        case 'missing-item': {
          const frag    = tpl('tpl-missing-item-new');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'Which items were missing in the order?';
          // Remove any plain-text hint already baked into the template
          frag.querySelectorAll('p, div').forEach(el => {
            if (el.textContent.includes('void fill paper')) el.remove();
          });
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-missing-item-new missing .sf-item-list');
          const hint = makeHintBox(
            'Sometimes smaller items can get lost in amongst the packaging — make sure to check in the void fill paper.'
          );
          list.parentNode.insertBefore(hint, list);
          const selectedIds = new Set(app.missingItems.map(x => String(x.id)));
          list.replaceWith(buildItemList(
            app.selectedOrder?.line_items || [], selectedIds,
            (li, checked) => {
              if (checked) {
                if (!app.missingItems.some(x => String(x.id) === String(li.id))) app.missingItems.push(li);
              } else {
                app.missingItems = app.missingItems.filter(x => String(x.id) !== String(li.id));
              }
            }
          ));
          show(frag);
          break;
        }

        case 'damaged-packaging':
          show(tpl('tpl-damaged-packaging'));
          break;

        case 'damaged-items': {
          const frag = tpl('tpl-damaged-items');
          app.uploaders.parcel = mountUploader(frag.querySelector('.sf-parcel-uploader'), { label: 'Upload parcel photo' });
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-damaged-items missing .sf-item-list');
          const selectedIds = new Set(app.damagedItems.map(x => String(x.id)));
          list.replaceWith(buildItemList(
            app.selectedOrder?.line_items || [], selectedIds,
            (li, checked) => {
              if (checked) {
                if (!app.damagedItems.some(x => String(x.id) === String(li.id))) app.damagedItems.push(li);
              } else {
                app.damagedItems = app.damagedItems.filter(x => String(x.id) !== String(li.id));
              }
            }
          ));
          show(frag);
          break;
        }

        case 'damaged-item-detail': {
          const item = app.damagedItems[app.damagedIdx];
          if (!item) { pushStep('damaged-extra'); return; }
          const frag    = tpl('tpl-damaged-item-detail');
          const titleEl = frag.querySelector('.sf-damaged-item-title');
          const stepEl  = frag.querySelector('.sf-damaged-step');
          if (titleEl) titleEl.textContent = 'Upload photos for: ' + item.title;
          if (stepEl)  stepEl.textContent  = 'Item ' + (app.damagedIdx + 1) + ' of ' + app.damagedItems.length;
          app.uploaders.item = mountUploader(frag.querySelector('.sf-damaged-item-uploader'), { label: 'Upload item photo(s)' });
          const existing = app.damagedItemDetails[item.id];
          const desc     = frag.querySelector('.sf-damaged-item-desc');
          if (desc && existing?.description) desc.value = existing.description;
          show(frag);
          break;
        }

        case 'damaged-extra':
          show(tpl('tpl-damaged-extra'));
          break;

        case 'contact-form': {
          renderContactForm({
            subject: buildSubject(),
            message: app.issueType === 'missing-item' && app.missingItems.length
              ? buildMissingItemMessage()
              : '',
            tags: ['order', app.issueType || ''].filter(Boolean),
          });
          break;
        }

        case 'success':
          renderSuccess();
          break;

        default:
          show(tpl('tpl-choose-issue'));
      }
    } catch (err) {
      renderFatal(err);
    }
  }

  function getContinueBtn(root) {
    return (
      root.querySelector('[data-action="confirm-orders"]') ||
      root.querySelector('.sf-continue-btn') ||
      [...root.querySelectorAll('button,a,[role="button"]')]
        .find(b => (b.textContent || '').trim().toLowerCase() === 'continue')
    );
  }

  // ── Submit: damaged ────────────────────────────────────────────────────────
  async function submitDamaged() {
    setStatus('Submitting…');
    try {
      const userMsg    = main.querySelector('.sf-extra-message')?.value?.trim() || '';
      const extraLines = ['Packaging damaged: ' + (app.packagingDamaged ? 'Yes' : 'No')];
      for (const li of app.damagedItems) {
        const det = app.damagedItemDetails[li.id] || {};
        extraLines.push('Damaged item: ' + li.title);
        if (det.description) extraLines.push('  Damage description: ' + det.description);
      }
      const keys = [
        ...(app.parcelKeys || []),
        ...Object.values(app.damagedItemDetails).flatMap(d => d.attachmentKeys || [])
      ];
      await apiPost('/tickets', {
        name:           customerName  || 'Customer',
        email:          customerEmail || '',
        subject:        'Order ' + (app.selectedOrder?.name || '') + ' had damaged items',
        message:        withContext(userMsg, extraLines),
        attachmentKeys: keys,
        tags:           ['order', 'issue:damaged'],
      });
      pushStep('success');
    } catch (e) { setStatus(e.message, 'error'); }
  }

  // ── Submit: contact form ───────────────────────────────────────────────────
  async function submitContactForm() {
    const submitBtn = main.querySelector('[data-action="submit-contact"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

    const resolvedName  = isLoggedIn() ? (customerName  || 'Customer') : (main.querySelector('.sf-cf-name')?.value?.trim()  || '');
    const resolvedEmail = isLoggedIn() ? (customerEmail || '')         : (main.querySelector('.sf-cf-email')?.value?.trim() || '');
    const subject = main.querySelector('.sf-cf-subject')?.value?.trim() || '';
    const message = main.querySelector('.sf-cf-message')?.value?.trim() || '';
    const keys    = app.uploaders.contact?.getKeys?.() || [];
    const tags    = app._contactTags || [];

    const fail = (msg) => {
      setStatus(msg, 'error');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send message'; }
    };
    if (!resolvedName)  { fail('Please enter your name.');  return; }
    if (!resolvedEmail) { fail('Please enter your email.'); return; }
    if (!subject)       { fail('Please enter a subject.');  return; }
    if (!message)       { fail('Please enter a message.');  return; }

    setStatus('Sending…');
    try {
      await apiPost('/tickets', {
        name:           resolvedName,
        email:          resolvedEmail,
        subject,
        message:        withContext(message),
        attachmentKeys: keys,
        tags,
      });
      pushStep('success');
    } catch (e) { fail(e.message); }
  }

  // ── Submit: other ──────────────────────────────────────────────────────────
  async function submitOther() {
    const resolvedName  = isLoggedIn() ? (customerName  || 'Customer') : (main.querySelector('.sf-cf-name')?.value?.trim()  || '');
    const resolvedEmail = isLoggedIn() ? (customerEmail || '')         : (main.querySelector('.sf-cf-email')?.value?.trim() || '');
    const subject = main.querySelector('.sf-cf-subject')?.value?.trim() || '';
    const message = main.querySelector('.sf-cf-message')?.value?.trim() || '';
    const keys    = app.uploaders.other?.getKeys?.() || [];
    if (!resolvedName)  { setStatus('Please enter your name.',  'error'); return; }
    if (!resolvedEmail) { setStatus('Please enter your email.', 'error'); return; }
    if (!subject)       { setStatus('Please enter a subject.',  'error'); return; }
    if (!message)       { setStatus('Please enter a message.',  'error'); return; }
    setStatus('Sending…');
    const lines = [
      '--- Support Context ---',
      'Customer: ' + (customerName  || '(unknown)'),
      'Email:    ' + (customerEmail || '(unknown)'),
      'Category: Other / general enquiry',
      '--- End Context ---',
      '',
      message,
    ];
    try {
      await apiPost('/tickets', {
        name:           resolvedName,
        email:          resolvedEmail,
        subject,
        message:        lines.join('\n'),
        attachmentKeys: keys,
        tags:           ['other'],
      });
      renderSuccess();
    } catch (e) { setStatus(e.message, 'error'); }
  }

  // ── Navigation capture ─────────────────────────────────────────────────────
  main.addEventListener('click', e => {
    if (!app.top || app.step === '') return;
    const t = e.target;
    if (!(t instanceof Element)) return;
    const a = t.closest('a[href]');
    if (a) {
      const href = (a.getAttribute('href') || '').trim();
      if (href && href !== '#' && !href.startsWith('#') && !href.toLowerCase().startsWith('javascript:'))
        e.preventDefault();
      return;
    }
    const btn = t.closest('button');
    if (btn) {
      const type = (btn.type || '').toLowerCase();
      if (!type || type === 'submit') e.preventDefault();
    }
    if (t.closest('input[type="submit"]')) e.preventDefault();
  }, true);

  // ── Main click handler ────────────���────────────────────────────────────────
  main.addEventListener('click', async e => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    if (t.closest('[data-action="back"],.sf-back')) {
      if (app.top === 'order-problem' && app.stepStack.length > 0) popStep();
      else goTop('');
      return;
    }

    const cat = t.closest('[data-category]');
    if (cat) {
      const v = (cat.getAttribute('data-category') || '').toLowerCase();
      goTop(v === 'order-problem' ? 'order-problem'
          : v === 'website'       ? 'website'
          : v === 'cultivation'   ? 'cultivation'
          : v === 'other'         ? 'other' : '');
      return;
    }

    if (t.closest('[data-action="show-other-form"]')) { app.top = 'other'; renderOtherForm(); return; }
    if (t.closest('[data-action="submit-other"]'))    { await submitOther();       return; }
    if (t.closest('[data-action="submit-contact"]'))  { await submitContactForm(); return; }

    if (app.top !== 'order-problem') return;

    const issue = t.closest('[data-issue]');
    if (issue) {
      app.issueType = (issue.getAttribute('data-issue') || '').toLowerCase();
      try { await loadOrders(); } catch (err) { renderFatal(err); return; }
      pushStep('select-order');
      return;
    }

    if (app.step === 'select-order') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (!app.selectedOrder) return;
        if      (app.issueType === 'not-arrived')  pushStep('delivery-type');
        else if (app.issueType === 'missing-item') pushStep('missing-item');
        else if (app.issueType === 'damaged')      pushStep('damaged-packaging');
        else                                        pushStep('contact-form');
        return;
      }
    }

    if (app.step === 'delivery-type') {
      const btn = t.closest('[data-delivery]');
      if (btn) {
        app.deliverySubType = btn.getAttribute('data-delivery');
        if (app.deliverySubType === 'other') {
          pushStep('contact-form');
        } else {
          pushStep('delivery-info');
        }
        return;
      }
    }

    if (app.step === 'delivery-info') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        pushStep('delivery-roadblock');
        return;
      }
      if (t.closest('[data-action="delivery-contact"]')) {
        pushStep('contact-form');
        return;
      }
      if (t.closest('[data-action="delivery-force-contact"]')) {
        renderContactForm({
          subject: 'Order ' + (app.selectedOrder?.name || '') + ' delivery issue',
          message: '',
          tags:    ['order', 'issue:delivery', 'subtype:early-contact'],
        });
        return;
      }
    }

    if (app.step === 'delivery-roadblock') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        pushStep('delivery-message');
        return;
      }
    }

    if (app.step === 'missing-item') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (!app.missingItems.length) { setStatus('Please select at least one missing item.', 'error'); return; }
        pushStep('contact-form');
        return;
      }
    }

    if (app.step === 'damaged-packaging') {
      const pkg = t.closest('[data-packaging]');
      if (pkg) {
        app.packagingDamaged = pkg.getAttribute('data-packaging') === 'true';
        pushStep('damaged-items');
        return;
      }
    }

    if (app.step === 'damaged-items') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (app.uploaders.parcel?.isUploading?.()) { setStatus('Please wait for upload to finish.', 'error'); return; }
        app.parcelKeys = app.uploaders.parcel?.getKeys?.() || [];
        if (!app.parcelKeys.length)   { setStatus('Please upload a photo of the damaged parcel.', 'error'); return; }
        if (!app.damagedItems.length) { setStatus('Please select which item(s) were damaged.',    'error'); return; }
        app.damagedIdx = 0;
        pushStep('damaged-item-detail');
        return;
      }
    }

    if (app.step === 'damaged-item-detail') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        const item = app.damagedItems[app.damagedIdx];
        if (!item) { pushStep('damaged-extra'); return; }
        if (app.uploaders.item?.isUploading?.()) { setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys = app.uploaders.item?.getKeys?.() || [];
        const desc = main.querySelector('.sf-damaged-item-desc')?.value?.trim() || '';
        if (!keys.length) { setStatus('Please upload at least one photo.', 'error'); return; }
        if (!desc)        { setStatus('Please describe the damage.',        'error'); return; }
        app.damagedItemDetails[item.id] = { attachmentKeys: keys, description: desc };
        app.damagedIdx += 1;
        if (app.damagedIdx >= app.damagedItems.length) pushStep('damaged-extra');
        else renderStep();
        return;
      }
    }

    if (app.step === 'damaged-extra') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && ['submit', 'send', 'continue'].includes((btn.textContent || '').trim().toLowerCase())) {
        await submitDamaged();
        return;
      }
    }
  });

  window.addEventListener('hashchange', () => {
    try { renderTop(); } catch (err) { renderFatal(err); }
  });

  try { renderTop(); } catch (err) { renderFatal(err); }

})();